import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const forRentWigsListSlice = createSlice({
  name: "forRentWigsListSlice",
  initialState,
  //REDUCER
  reducers: {
    setForRentWigsList(state, action) {
      return {
        ...state,
        rows: action.payload,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    // addItems(state, action) {
    //   return {
    //     ...state,
    //     rows: [...state.rows, action.payload],
    //   };
    // },
    // editItems(state, action) {
    //   return {
    //     ...state,
    //     rows: state.rows.map((row) =>
    //       row.id === action.payload.id ? action.payload : row
    //     ),
    //   };
    // },
    // deleteItems(state, action) {
    //   return {
    //     ...state,
    //     rows: state.rows.filter((row) => row.id !== action.payload),
    //   };
    // },
  },
});

//ACTIONS
export const {
    setForRentWigsList,
    showLoading,
    hideLoading,
    // addItems,
    // editItems,
    // deleteItems,
} = forRentWigsListSlice.actions;

export default forRentWigsListSlice.reducer;
